import React from 'react'

export const Innovate = (props) => {
    return ( <svg
        id="innovate"
        xmlns="http://www.w3.org/2000/svg"
        width="72"
        height="85.444"
        viewBox="0 0 72 85.444"
      >
        <g
          id="Group_883"
          data-name="Group 883"
          transform="translate(0.011)"
        >
          <path
            id="Path_3485"
            data-name="Path 3485"
            d="M12.7,20.35,2.444,16.322a1.548,1.548,0,0,0-.732-.122H1.589A1.737,1.737,0,0,0,0,18.031,1.945,1.945,0,0,0,1.1,19.5l10.253,4.028a1.1,1.1,0,0,0,.61.122,1.576,1.576,0,0,0,1.587-1.1,2.5,2.5,0,0,0,0-1.343A1.474,1.474,0,0,0,12.7,20.35Z"
            transform="translate(0 3.574)"
            fill="#1d8f61"
          />
          <path
            id="Path_3486"
            data-name="Path 3486"
            d="M41.093,15.39a1.96,1.96,0,0,0,1.343-.61l3.54-4.15a1.731,1.731,0,0,0-.122-2.441,2.193,2.193,0,0,0-1.1-.488h0a1.96,1.96,0,0,0-1.343.61l-3.54,4.15a1.475,1.475,0,0,0-.366,1.221,1.7,1.7,0,0,0,.61,1.221A1.11,1.11,0,0,0,41.093,15.39Z"
            transform="translate(8.711 1.699)"
            fill="#1d8f61"
          />
          <path
            id="Path_3487"
            data-name="Path 3487"
            d="M29.709,0A1.669,1.669,0,0,0,28,1.709V11.6a1.709,1.709,0,1,0,3.418,0V1.709A1.666,1.666,0,0,0,29.709,0Z"
            transform="translate(6.18)"
            fill="#1d8f61"
          />
          <path
            id="Path_3488"
            data-name="Path 3488"
            d="M15.509,7.7A1.669,1.669,0,0,0,13.8,9.409a1.325,1.325,0,0,0,.488,1.1l3.54,4.15a1.8,1.8,0,0,0,2.441.244,1.5,1.5,0,0,0,.61-1.221,2.062,2.062,0,0,0-.366-1.221l-3.54-4.15a2.536,2.536,0,0,0-1.465-.61Z"
            transform="translate(3.047 1.699)"
            fill="#1d8f61"
          />
          <path
            id="Path_3489"
            data-name="Path 3489"
            d="M38.45,27.8h-.366a2.5,2.5,0,0,0-1.1.61l-7.2,8.666-.732,1.1-.977-.977-1.831-1.831h0a1.749,1.749,0,0,0-1.343-.61,1.7,1.7,0,0,0-1.1.366,1.731,1.731,0,0,0-.122,2.441l.122.122h0l4.028,4.028a1.77,1.77,0,0,0,2.441,0l.122-.122L39.67,30.485a1.238,1.238,0,0,0,.366-1.221,2.874,2.874,0,0,0-.61-1.221C39.182,28.044,38.816,27.8,38.45,27.8Z"
            transform="translate(5.129 6.134)"
            fill="#1d8f61"
          />
          <path
            id="Path_3490"
            data-name="Path 3490"
            d="M61.371,17.321A1.856,1.856,0,0,0,59.784,16.1h0a1.548,1.548,0,0,0-.732.122L48.8,20.25a1.713,1.713,0,0,0-.977,2.2,1.738,1.738,0,0,0,1.587,1.1,1.1,1.1,0,0,0,.61-.122l10.253-3.906a1.948,1.948,0,0,0,1.1-.854A2.5,2.5,0,0,0,61.371,17.321Z"
            transform="translate(10.526 3.552)"
            fill="#1d8f61"
          />
          <path
            id="Path_3491"
            data-name="Path 3491"
            d="M37.637,68.909A1.669,1.669,0,0,0,35.928,67.2H25.309a1.7,1.7,0,0,0-1.221.61,1.567,1.567,0,0,0-.488,1.221,1.645,1.645,0,0,0,1.709,1.587H35.928A1.669,1.669,0,0,0,37.637,68.909Z"
            transform="translate(5.209 14.826)"
            fill="#a8a8a8"
          />
          <path
            id="Path_3492"
            data-name="Path 3492"
            d="M33.471,15.9h-.244A21.651,21.651,0,0,0,22.119,56.181l.61.366V71.439a1.669,1.669,0,0,0,1.709,1.709H42.26a1.669,1.669,0,0,0,1.709-1.709V56.547l.61-.366a21.022,21.022,0,0,0,9.887-13.3A21.153,21.153,0,0,0,52.025,26.4,21.618,21.618,0,0,0,33.471,15.9Zm7.2,48.7V69.73H26.27V63.383h14.4Zm.854-10.375a1.635,1.635,0,0,0-.977,1.587v4.15h-14.4v-4.15a1.9,1.9,0,0,0-.977-1.587,18.512,18.512,0,0,1-9.277-10.619A18.456,18.456,0,0,1,33.349,19.318,18.794,18.794,0,0,1,46.41,24.689a17.871,17.871,0,0,1,5.371,13.061A18.244,18.244,0,0,1,41.528,54.228Z"
            transform="translate(2.54 3.508)"
            fill="#a8a8a8"
          />
        </g>
      </svg>)
}

export const Disrupt = props => {
    return (
        <svg
        id="disrupt"
        xmlns="http://www.w3.org/2000/svg"
        width="86.012"
        height="109.012"
        viewBox="0 0 86.012 109.012"
      >
        <g
          id="Group_882"
          data-name="Group 882"
          transform="translate(-7893.707 -10730.041)"
        >
          <g id="Group_881" data-name="Group 881">
            <path
              id="Path_3479"
              data-name="Path 3479"
              d="M7906.313,10782.547h-11.2a1.372,1.372,0,0,0-1.406,1.338,1.279,1.279,0,0,0,.006.162,1.373,1.373,0,0,0,1.237,1.5,1.287,1.287,0,0,0,.163,0h11.2a1.371,1.371,0,0,0,1.4-1.337,1.393,1.393,0,0,0,0-.163,1.373,1.373,0,0,0-1.238-1.494A1.5,1.5,0,0,0,7906.313,10782.547Z"
              fill="#448b65"
            />
            <path
              id="Path_3480"
              data-name="Path 3480"
              d="M7978.313,10782.547h-11.2a1.372,1.372,0,0,0-1.406,1.338,1.279,1.279,0,0,0,.006.162,1.373,1.373,0,0,0,1.237,1.5,1.287,1.287,0,0,0,.163,0h11.2a1.371,1.371,0,0,0,1.4-1.337,1.393,1.393,0,0,0,0-.163,1.373,1.373,0,0,0-1.238-1.494A1.5,1.5,0,0,0,7978.313,10782.547Z"
              fill="#448b65"
            />
            <path
              id="Path_3483"
              data-name="Path 3483"
              d="M7939.213,10837.647v-11.2a1.373,1.373,0,0,0-1.338-1.405,1.279,1.279,0,0,0-.162,0,1.373,1.373,0,0,0-1.5,1.238,1.279,1.279,0,0,0,0,.162v11.2a1.371,1.371,0,0,0,1.337,1.405,1.513,1.513,0,0,0,.163-.006,1.371,1.371,0,0,0,1.494-1.237A1.5,1.5,0,0,0,7939.213,10837.647Z"
              fill="#448b65"
            />
            <path
              id="Path_3482"
              data-name="Path 3482"
              d="M7936.213,10731.447v11.2a1.371,1.371,0,0,0,1.337,1.405,1.513,1.513,0,0,0,.163-.006,1.371,1.371,0,0,0,1.494-1.237,1.5,1.5,0,0,0,.006-.162v-11.2a1.373,1.373,0,0,0-1.338-1.405,1.279,1.279,0,0,0-.162,0,1.373,1.373,0,0,0-1.5,1.238A1.279,1.279,0,0,0,7936.213,10731.447Z"
              fill="#448b65"
            />
          </g>
        </g>
        <path
          id="Path_8538"
          data-name="Path 8538"
          d="M7958.926,10780.477c.023-.049.04-.1.059-.151a1.581,1.581,0,0,0,.057-.156c.011-.042.015-.087.023-.13a1.721,1.721,0,0,0,.03-.2l0-.019c0-.035,0-.068,0-.1a2.034,2.034,0,0,0-.01-.211c-.007-.05-.02-.1-.031-.146a1.475,1.475,0,0,0-.043-.175c-.017-.049-.039-.095-.059-.142s-.047-.107-.076-.16-.056-.084-.085-.126a1.684,1.684,0,0,0-.106-.143c-.037-.043-.08-.08-.121-.119a1.325,1.325,0,0,0-.1-.1l-.021-.015a1.774,1.774,0,0,0-.153-.1c-.044-.027-.086-.058-.131-.08s-.087-.034-.13-.052a1.806,1.806,0,0,0-.184-.068c-.03-.008-.062-.01-.093-.017a1.71,1.71,0,0,0-.242-.038l-.015,0-18.728-1.035,11.185-26.919c.007-.019.009-.037.016-.055.021-.057.036-.113.051-.171s.028-.1.037-.157.011-.105.015-.159.008-.114.006-.17-.01-.1-.016-.155-.014-.112-.027-.166-.03-.1-.047-.157a1.478,1.478,0,0,0-.055-.149,1.326,1.326,0,0,0-.078-.147,1.581,1.581,0,0,0-.085-.141c-.03-.042-.064-.082-.1-.122s-.08-.092-.125-.135a.414.414,0,0,0-.037-.04.941.941,0,0,0-.081-.059,1.485,1.485,0,0,0-.149-.107,1.342,1.342,0,0,0-.15-.08,1,1,0,0,0-.095-.052c-.019-.009-.038-.011-.056-.018-.057-.021-.114-.036-.172-.051s-.1-.027-.152-.035a1.709,1.709,0,0,0-.173-.016,1.356,1.356,0,0,0-.154,0c-.06,0-.118.01-.177.018a1.431,1.431,0,0,0-.143.023,1.325,1.325,0,0,0-.181.055c-.043.015-.085.028-.126.046a1.5,1.5,0,0,0-.168.089,1.288,1.288,0,0,0-.121.073c-.048.033-.092.072-.137.109s-.082.071-.12.111c-.015.016-.031.026-.045.041l-33.359,37.634c-.03.034-.051.073-.078.109-.013.017-.025.034-.037.052a1.846,1.846,0,0,0-.127.21c-.016.032-.03.066-.045.1a1.775,1.775,0,0,0-.07.194c-.013.044-.022.088-.031.135a1.6,1.6,0,0,0-.027.19c0,.024-.009.046-.01.07s0,.052,0,.078c0,.061,0,.121.011.182s.014.105.025.157a1.512,1.512,0,0,0,.043.161c.017.052.034.1.055.152a1.519,1.519,0,0,0,.074.149,1.435,1.435,0,0,0,.084.139c.031.046.065.089.1.133a1.444,1.444,0,0,0,.115.124c.02.021.036.044.058.064a.406.406,0,0,0,.038.021,1.647,1.647,0,0,0,.461.277c.029.012.057.021.087.031a1.666,1.666,0,0,0,.475.095l17.986.716-10.756,31.651c0,.011,0,.023-.008.035a1.551,1.551,0,0,0-.046.2c-.009.045-.02.09-.025.135s0,.118,0,.177,0,.1,0,.155.018.11.028.166.018.1.032.152.041.111.063.166.034.092.057.136a1.621,1.621,0,0,0,.094.151c.028.043.053.086.085.126a1.66,1.66,0,0,0,.113.122,1.491,1.491,0,0,0,.122.12c.012.01.021.023.033.033s.033.015.048.026a1.673,1.673,0,0,0,.443.243.217.217,0,0,0,.024.012h0a1.68,1.68,0,0,0,.377.063c.057,0,.112.028.168.028h0a1.665,1.665,0,0,0,.459-.072,1.067,1.067,0,0,0,.119-.04,1.607,1.607,0,0,0,.332-.165c.03-.019.062-.034.09-.055a1.725,1.725,0,0,0,.325-.3l33.6-41.94c.009-.011.014-.024.022-.035a1.426,1.426,0,0,0,.1-.156C7958.876,10780.56,7958.9,10780.52,7958.926,10780.477Zm-22.033,7.936c.008-.023.009-.047.016-.07a1.762,1.762,0,0,0,.04-.172c.011-.057.019-.115.024-.172,0-.023.008-.043.009-.066s0-.055,0-.084a1.84,1.84,0,0,0-.011-.187c-.007-.052-.016-.1-.027-.154s-.026-.108-.043-.162a1.624,1.624,0,0,0-.059-.154c-.021-.05-.045-.1-.07-.144s-.056-.095-.087-.141-.064-.087-.1-.129a1.381,1.381,0,0,0-.109-.118,1.5,1.5,0,0,0-.124-.111,1.518,1.518,0,0,0-.133-.1,1.312,1.312,0,0,0-.138-.082,1.737,1.737,0,0,0-.165-.076c-.028-.011-.053-.027-.081-.037s-.045-.009-.068-.015a1.625,1.625,0,0,0-.167-.039c-.061-.011-.121-.021-.182-.026-.022,0-.041-.007-.063-.008l-16.677-.663,24.237-27.344-8.205,19.75a1.336,1.336,0,0,0-.041.135c-.014.043-.029.086-.04.131a1.621,1.621,0,0,0-.031.2.87.87,0,0,0-.015.095c0,.017,0,.031,0,.047a1.782,1.782,0,0,0,.008.191c.005.05.007.1.016.149s.026.109.041.163.028.105.047.155a1.48,1.48,0,0,0,.071.148c.024.048.046.1.074.141a1.608,1.608,0,0,0,.1.14c.031.04.06.08.094.117s.085.08.129.119.077.069.12.1.092.058.14.085.1.059.154.084c.016.007.029.018.046.023a1,1,0,0,0,.109.033,1.481,1.481,0,0,0,.162.049,1.7,1.7,0,0,0,.183.029c.035,0,.068.014.1.016l17.826.985-25.49,31.813Z"
          transform="translate(-7893.707 -10730.041)"
          fill="#a7a7a7"
        />
      </svg>
    )
}

export const Analyze = (props) => {
    return (
        <svg
        id="analyse"
        xmlns="http://www.w3.org/2000/svg"
        width="63.739"
        height="57.459"
        viewBox="0 0 63.739 57.459"
      >
        <path
          id="Path_8011"
          data-name="Path 8011"
          d="M2500.02,8268.427a1.858,1.858,0,0,0,2.168-1.831v-7.869a1.838,1.838,0,0,0-1.82-1.855h-7.978a1.838,1.838,0,0,0-1.856,1.82v.068a1.821,1.821,0,0,0,1.822,1.821h3.444l-6.38,6.313a24.47,24.47,0,0,0-42.84,23.388l-7.573,7.5a1.793,1.793,0,0,0-.064,2.536c.021.021.042.043.064.063a1.86,1.86,0,0,0,2.6,0l6.756-6.831a23.466,23.466,0,0,0,2.97,3.639,24.482,24.482,0,0,0,32.353,1.969l13.11,13.109a3.012,3.012,0,1,0,4.26-4.26l-12.99-12.991a24.461,24.461,0,0,0,3.21-24.635l7.2-7.2v3.316A1.926,1.926,0,0,0,2500.02,8268.427Zm-16.613,26.234h0a20.79,20.79,0,1,1,0-29.4A20.838,20.838,0,0,1,2483.406,8294.662Z"
          transform="translate(-2438.449 -8255.691)"
          fill="#a7a7a7"
        />
        <path
          id="Path_8012"
          data-name="Path 8012"
          d="M2481.327,8275.056l-7.276,7.276-3.564-3.564-4.9-4.9c-.021-.022-.042-.043-.064-.064a1.8,1.8,0,0,0-2.536.064l-8.613,8.613a1.86,1.86,0,0,0,0,2.6c.021.021.042.043.064.063a1.793,1.793,0,0,0,2.536-.063l7.276-7.272,3.563,3.563,4.9,4.9.063.063a1.8,1.8,0,0,0,2.537-.063l8.613-8.538v-.006l.011-.011a1.883,1.883,0,0,0-.011-2.662c-.021-.021-.042-.043-.064-.063A1.794,1.794,0,0,0,2481.327,8275.056Z"
          transform="translate(-2438.449 -8255.691)"
          fill="#448b65"
        />
      </svg>
    )
}

export const Transform = (props) => {
    return (
        <svg
        id="transform"
        xmlns="http://www.w3.org/2000/svg"
        width="65.909"
        height="66"
        viewBox="0 0 65.909 66"
      >
        <g
          id="Group_880"
          data-name="Group 880"
          transform="translate(0 0.025)"
        >
          <g
            id="Group_879"
            data-name="Group 879"
            transform="translate(0 -0.025)"
          >
            <path
              id="Path_3460"
              data-name="Path 3460"
              d="M21.551,289.259a1.755,1.755,0,1,0-2.482,2.482l1.986,1.986h-8.06A9.5,9.5,0,0,1,3.5,284.236v-5.884a1.752,1.752,0,0,0-3.5,0v5.884a13,13,0,0,0,12.995,12.995h8.06l-1.986,1.986a1.752,1.752,0,0,0,1.241,2.993,1.783,1.783,0,0,0,1.241-.511l4.979-4.979a1.754,1.754,0,0,0,0-2.482Z"
              transform="translate(0 -236.21)"
              fill="#1d8f61"
            />
            <path
              id="Path_3461"
              data-name="Path 3461"
              d="M31.431,0H2.652A1.757,1.757,0,0,0,.9,1.752V30.531a1.757,1.757,0,0,0,1.752,1.752H31.431a1.757,1.757,0,0,0,1.752-1.752V1.752A1.748,1.748,0,0,0,31.431,0ZM29.678,28.778H4.4V3.5H29.678Z"
              transform="translate(-0.769 0.004)"
              fill="#a8a8a8"
            />
            <path
              id="Path_3462"
              data-name="Path 3462"
              d="M280.21,4.958h-8.06l1.986-1.986A1.755,1.755,0,0,0,271.654.49L266.69,5.469a1.754,1.754,0,0,0,0,2.482l4.979,4.979a1.758,1.758,0,0,0,1.241.511,1.783,1.783,0,0,0,1.241-.511,1.754,1.754,0,0,0,0-2.482l-1.986-1.986h8.06a9.5,9.5,0,0,1,9.491,9.491v5.884a1.752,1.752,0,1,0,3.5,0V17.952A13.017,13.017,0,0,0,280.21,4.958Z"
              transform="translate(-227.311 0.025)"
              fill="#1d8f61"
            />
            <path
              id="Path_3463"
              data-name="Path 3463"
              d="M428.252,428a1.745,1.745,0,0,0-1.752,1.752,1.8,1.8,0,0,0,.511,1.241,1.755,1.755,0,0,0,2.482-2.482A1.822,1.822,0,0,0,428.252,428Z"
              transform="translate(-364.227 -365.504)"
              fill="#a8a8a8"
            />
            <path
              id="Path_3464"
              data-name="Path 3464"
              d="M378.952,428a1.752,1.752,0,1,0,1.752,1.752A1.757,1.757,0,0,0,378.952,428Z"
              transform="translate(-322.125 -365.504)"
              fill="#a8a8a8"
            />
            <path
              id="Path_3465"
              data-name="Path 3465"
              d="M280.352,428a1.752,1.752,0,1,0,1.752,1.752A1.757,1.757,0,0,0,280.352,428Z"
              transform="translate(-237.922 -365.504)"
              fill="#a8a8a8"
            />
            <path
              id="Path_3466"
              data-name="Path 3466"
              d="M329.652,428a1.752,1.752,0,1,0,1.752,1.752A1.757,1.757,0,0,0,329.652,428Z"
              transform="translate(-280.023 -365.504)"
              fill="#a8a8a8"
            />
            <path
              id="Path_3467"
              data-name="Path 3467"
              d="M231.152,428a1.745,1.745,0,0,0-1.752,1.752,1.8,1.8,0,0,0,.511,1.241,1.769,1.769,0,0,0,1.241.511,1.8,1.8,0,0,0,1.241-.511,1.763,1.763,0,0,0,0-2.482A1.8,1.8,0,0,0,231.152,428Z"
              transform="translate(-195.905 -365.504)"
              fill="#a8a8a8"
            />
            <path
              id="Path_3468"
              data-name="Path 3468"
              d="M231.152,378.7a1.752,1.752,0,1,0,1.752,1.752A1.757,1.757,0,0,0,231.152,378.7Z"
              transform="translate(-195.905 -323.402)"
              fill="#a8a8a8"
            />
            <path
              id="Path_3469"
              data-name="Path 3469"
              d="M231.152,329.4a1.752,1.752,0,1,0,1.752,1.752A1.757,1.757,0,0,0,231.152,329.4Z"
              transform="translate(-195.905 -281.301)"
              fill="#a8a8a8"
            />
            <path
              id="Path_3470"
              data-name="Path 3470"
              d="M231.152,280.1a1.752,1.752,0,1,0,1.752,1.752A1.757,1.757,0,0,0,231.152,280.1Z"
              transform="translate(-195.905 -239.199)"
              fill="#a8a8a8"
            />
            <path
              id="Path_3471"
              data-name="Path 3471"
              d="M231.152,230.9a1.752,1.752,0,1,0,0,3.5,1.8,1.8,0,0,0,1.241-.511,1.769,1.769,0,0,0,.511-1.241,1.8,1.8,0,0,0-.511-1.241A1.758,1.758,0,0,0,231.152,230.9Z"
              transform="translate(-195.905 -197.183)"
              fill="#a8a8a8"
            />
            <path
              id="Path_3472"
              data-name="Path 3472"
              d="M378.952,230.9a1.752,1.752,0,1,0,1.752,1.752A1.757,1.757,0,0,0,378.952,230.9Z"
              transform="translate(-322.125 -197.183)"
              fill="#a8a8a8"
            />
            <path
              id="Path_3473"
              data-name="Path 3473"
              d="M329.652,230.9a1.752,1.752,0,1,0,1.752,1.752A1.757,1.757,0,0,0,329.652,230.9Z"
              transform="translate(-280.023 -197.183)"
              fill="#a8a8a8"
            />
            <path
              id="Path_3474"
              data-name="Path 3474"
              d="M280.352,230.9a1.752,1.752,0,1,0,1.752,1.752A1.757,1.757,0,0,0,280.352,230.9Z"
              transform="translate(-237.922 -197.183)"
              fill="#a8a8a8"
            />
            <path
              id="Path_3475"
              data-name="Path 3475"
              d="M428.252,230.9A1.755,1.755,0,1,0,430,232.652a1.8,1.8,0,0,0-.511-1.241A1.822,1.822,0,0,0,428.252,230.9Z"
              transform="translate(-364.227 -197.183)"
              fill="#a8a8a8"
            />
            <path
              id="Path_3476"
              data-name="Path 3476"
              d="M428.252,280.1A1.752,1.752,0,1,0,430,281.852,1.757,1.757,0,0,0,428.252,280.1Z"
              transform="translate(-364.227 -239.199)"
              fill="#a8a8a8"
            />
            <path
              id="Path_3477"
              data-name="Path 3477"
              d="M428.252,378.7A1.752,1.752,0,1,0,430,380.452,1.757,1.757,0,0,0,428.252,378.7Z"
              transform="translate(-364.227 -323.402)"
              fill="#a8a8a8"
            />
            <path
              id="Path_3478"
              data-name="Path 3478"
              d="M428.252,329.4A1.752,1.752,0,1,0,430,331.152,1.757,1.757,0,0,0,428.252,329.4Z"
              transform="translate(-364.227 -281.301)"
              fill="#a8a8a8"
            />
          </g>
        </g>
      </svg>
    )
}